import { FC } from 'react';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Field } from 'formik';
import { Typography } from '@mui/material';
import { Reorder } from '@mui/icons-material';
import { ActionButton, InputField } from '@ui/index';
import { $mode, clarifiedPrice } from '../../models';
import { Ticket } from '../../interfaces';
import { Wrapper, StyledStatus, StyledOffers, StyledOffer, StyledPriceRange, StyledText } from './styled';
interface Props {
  values: Ticket;
}

export const TicketMarketOrders: FC<Props> = ({ values }) => {
  const { t } = useTranslation();
  const [mode] = useUnit([$mode]);

  const onClickPayment = (number: string) => () => {
    const marketOrder = values.marketOrders
      .find((marketOrder) => marketOrder.number === number);
    if (marketOrder) {
      const offers = marketOrder.offers
        .filter((offer) => offer.is_price_range)
        .map((offer) => ({
          id: offer.id,
          clarified_price: Number(offer.clarified_price ? offer.clarified_price : offer.price)
        }));

      clarifiedPrice({ order: { number }, offers });
    }
  };

  return (
    <>
      {values.marketOrders.map((marketOrder) => {
        const isPriceRange = marketOrder.offers.find(({ is_price_range }) => is_price_range === true);
        const isPriceClarification = marketOrder.status.name === 'price-clarification';
        return (
            <Wrapper key={marketOrder.number}>
              <ActionButton
                kind="basic"
                icon={<Reorder style={{ marginRight: 0 }} />}
                style={{ padding: 0 }}
              />
              <StyledOffers>
                <StyledOffer>
                  <Typography variant="subtitle2">{t('OrderFromTheMarket')} №{marketOrder.number}</Typography>
                  <Typography variant="subtitle2">{marketOrder.total.display}</Typography>
                </StyledOffer>
    
                {marketOrder.offers.map((offer, index) => (
                  <StyledOffer key={offer.id}>
                    <Typography variant="body2">
                      {offer.title}
                      {marketOrder.status.name === 'price-clarification' && offer.is_price_range && (
                        <StyledPriceRange>&nbsp;{t('MarketFrom')}</StyledPriceRange>
                      )}
                    </Typography>
                    <Typography variant="body2" style={{ display: 'flex', alignItems: 'baseline' }}>
                      {offer.is_price_range ? (
                        <Field
                          name={`marketOrders.${index}.offers.${index}.${offer.clarified_price ? 'clarified_price' : 'price'}`}
                          label={null}
                          placeholder={t('AmountPayable')}
                          mode={mode === 'edit' && marketOrder.status.name === 'price-clarification' ? 'edit' : 'view'}
                          component={InputField}
                          divider={false}
                          type="number"
                          style={{ '& input': { textAlign: 'right' } }}
                        />
                      ) : (
                        <Field
                          name={`marketOrders.${index}.offers.${index}.${offer.clarified_price ? 'clarified_price' : 'price'}`}
                          label={null}
                          placeholder={t('AmountPayable')}
                          mode="view"
                          component={InputField}
                          divider={false}
                          type="number"
                          style={{ '& input': { textAlign: 'right' } }}
                        />
                      )}
                      &nbsp;
                      {t('rub')}
                    </Typography>
                  </StyledOffer>
                ))}
                {mode === 'edit' && isPriceRange && isPriceClarification && (
                  <ActionButton
                    kind="positive"
                    onClick={onClickPayment(marketOrder.number)}
                    style={{ float: 'right' }}
                  >
                    {t('SendForPayment')}
                  </ActionButton>
                )}
              
              </StyledOffers>
              <StyledStatus color={marketOrder.status.name}>
                {marketOrder.status.title}
                {marketOrder.status.name === 'price-clarification' && (
                  <StyledText>{t('PleaseIndicateTheFinalCostOfTheOrderIssueInvoice')}</StyledText>
                )}
              </StyledStatus>
            </Wrapper>
          )
      })}
    </>
  )
};
